export const initStoreTimes = function (detailYn) {
  var tmp = []

  var len = detailYn ? 8 : 3

  for (var i = 1; i < len; i++) {
    tmp.push({
      week: i,
      dayYn: false,
      startTm: null,
      endTm: null,
      breakStartTm1: null,
      breakEndTm1: null,
      breakStartTm2: null,
      breakEndTm2: null,
      isHoliday: false,
      isBatch: detailYn ? (i < 6 ? true : false) : false,
    })
  }

  return tmp
}
